<div class="d-flex">
  <div class="ps-3 d-flex flex-column gap-3 mb-4">
    <!-- FULL NAME -->
    <div class="hstack gap-3">
      <app-data-box [label]="'Cognome'" [data]="user?.cognome" [boldData]="true"></app-data-box>
      <app-data-box [label]="'Nome'" [data]="user?.nome" [boldData]="true"></app-data-box>
      <app-data-box [label]="'Secondo Nome'" [data]="user?.secondo_nome" [boldData]="true"></app-data-box>
    </div>
    <!-- DATA -->
    <div *ngIf="showFullData" class="hstack gap-3">
      <app-data-box [label]="'Codice Fiscale'" [data]="user?.codice_fiscale"></app-data-box>
      <app-data-box *ngIf="user?.hasClass()" [label]="'Classe'" [data]="user?.classe?.getName()"
        title="Copia: {{user?.classe?.getName()}} • Doppio click: Visualizza la classe"
        (doubleClick)="goToClass(user?.classe?.id)">
        <i *ngIf="isRappresentanteDiClasse()" class="bi bi-patch-check-fill ms-2 opacity-50"
          title="Rappresentante di Classe"></i>
      </app-data-box>
    </div>
    <!-- CONTACTS -->
    <div class="hstack gap-3 d-flex align-items-start">
      <div class="d-flex flex-column gap-3">
        <div *ngFor="let phoneContact of user?.contatti?.phone;">
          <app-phone-box [data]="phoneContact"></app-phone-box>
        </div>
        <div *ngIf="user?.contatti?.phone?.length == 0;">
          <app-phone-box [data]=""></app-phone-box>
        </div>
      </div>
      <div class="d-flex flex-column gap-3">
        <div *ngFor="let emailContact of user?.contatti?.email;">
          <app-email-box [data]="emailContact"></app-email-box>
        </div>
        <div *ngIf="user?.contatti?.email?.length == 0;">
          <app-email-box [data]=""></app-email-box>
        </div>
      </div>
    </div>
    <!-- BES / REL -->
    <div *ngIf="user?.isStudent() && showTags" class="d-flex align-items-start gap-3">
      <app-dea-chip-status [label]="'BES'" [status]="user?.bisogni_educativi_speciali?.enable"
        [clickHandler]="user?.bisogni_educativi_speciali?.enable ? openBesDetailsDialog : undefined"
        [title]="user?.bisogni_educativi_speciali?.enable ? 'Visualizza dettagli: Bisogni Educativi Speciali' : undefined" />
      <app-dea-chip-status [label]="'REL'" [status]="user?.religione" [title]="'Religione'" />
      <app-dea-chip-status [label]="'ATL'" [status]="user?.atleta?.enable"
        [clickHandler]="user?.atleta?.enable ? openAtlDetailsDialog : undefined"
        [title]="user?.atleta?.enable ? 'Visualizza dettagli: Atleta': undefined" />
      <app-dea-chip-status [label]="'FULL'" [status]="user?.full_school" [title]="'Full School'" />
      <app-dea-chip-status [label]="'EST'" [status]="user?.estero" [title]="'Anno all\'estero'" />
    </div>
    <!-- SUBJECTS & TEACHER-CERTIFICATION -->
    <div *ngIf="user?.isTeacher()" class="d-flex flex-column align-items-start gap-3">
      <app-dea-label [label]="'Materie:'"></app-dea-label>
      <div class="d-flex gap-3 d-flex align-items-start flex-wrap">
        <div class="rounded-3 shadow-sm px-4 py-2" *ngFor="let subject of user?.materie;">
          {{subject.nome}}
        </div>
      </div>
      <app-dea-label *ngIf="user?.certified !== undefined" [label]="'Informazioni:'"></app-dea-label>
      <div class="d-flex gap-3 d-flex align-items-start flex-wrap">
        <app-dea-chip-status *ngIf="user?.certified !== undefined" [label]="'ABILITAZIONE'"
          [status]="user?.certified || false" />
        <app-dea-chip-status *ngIf="user?.photoReleaseForm !== undefined" [label]="'LIBERATORIA'"
          [status]="user?.photoReleaseForm || false" />
      </div>
    </div>
  </div>
  <div *ngIf="showArrow" class="my-auto">
    <!-- GO TO DETAIL -->
    <button id="user-detail-arrow-btn" mat-icon-button aria-label="Dettagli Utente"
      title="Dettagli {{user?.getFullName()}}" routerLink="/utente/{{user?.id}}">
      <mat-icon class="pe-1 mb-1" aria-hidden="false" aria-label="Dettagli Utente"
        fontIcon="arrow_forward_ios"></mat-icon>
    </button>
  </div>
</div>